import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../../../utils/bonus';

import {
  TXTCLI_You_can_make_N0_depositsX_incl_ELL,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_10,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_11,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_12,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_13,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_2,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_3,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_4,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_5,
  TXTCLI_You_must_complete_your_deposit_ELL
} from './LastEligibleDeposits.messages.json';

interface Props {
  isSingleTicket: boolean;
  isLastPotentialTicketReward: boolean;
  lastEligibleDepositTime: JSX.Element;
}

const LastEligibleDeposits: React.FC<Props> = ({
  isSingleTicket,
  isLastPotentialTicketReward,
  lastEligibleDepositTime
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    maxNumberOfDepositsLeft,
    lastAllowedDepositTime,
    maxNumberOfDeposits,
    maxNumTickets,
    maxDaysForDepositLeft
  } = preCashinInfo as PreCashinInfo;

  if (maxDaysForDepositLeft) {
    return maxNumberOfDeposits === maxNumberOfDepositsLeft ? (
      <Translation
        {...TXTCLI_You_can_make_N0_depositsX_incl_ELL}
        values={{
          0: maxNumberOfDepositsLeft,
          1: maxDaysForDepositLeft,
          2: lastEligibleDepositTime
        }}
      />
    ) : (
      <>
        <Translation
          {...getBonusMessage(
            Messages.FinalEligibleDeposit,
            isSingleTicket,
            isLastPotentialTicketReward
          )}
          values={{ 0: maxNumTickets }}
        />
        <Translation
          {...TXTCLI_You_must_complete_your_deposit_ELL}
          values={{ 0: lastEligibleDepositTime }}
        />
      </>
    );
  }

  if (isSingleTicket) {
    return !lastAllowedDepositTime ? (
      <Translation
        {...(isLastPotentialTicketReward
          ? TXTCLI_You_can_make_Xb_classXXredXX1__ELL_4
          : TXTCLI_You_can_make_Xb_classXXredXX1__ELL_5)}
        values={{ 0: maxNumTickets }}
      />
    ) : (
      <Translation
        {...(isLastPotentialTicketReward
          ? TXTCLI_You_can_make_Xb_classXXredXX1__ELL_2
          : TXTCLI_You_can_make_Xb_classXXredXX1__ELL_3)}
        values={{
          0: lastEligibleDepositTime,
          1: maxNumTickets
        }}
      />
    );
  }

  return !lastAllowedDepositTime ? (
    <Translation
      {...(isLastPotentialTicketReward
        ? TXTCLI_You_can_make_Xb_classXXredXX1__ELL_12
        : TXTCLI_You_can_make_Xb_classXXredXX1__ELL_10)}
      values={{ 0: maxNumTickets }}
    />
  ) : (
    <Translation
      {...(isLastPotentialTicketReward
        ? TXTCLI_You_can_make_Xb_classXXredXX1__ELL_13
        : TXTCLI_You_can_make_Xb_classXXredXX1__ELL_11)}
      values={{
        0: isLastPotentialTicketReward ? lastEligibleDepositTime : maxNumTickets,
        1: lastEligibleDepositTime
      }}
    />
  );
};

export default LastEligibleDeposits;
